import {
  configApiRef,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import {
  ApiBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import {
  TechDocsAddonLocations,
  techdocsStorageApiRef,
} from '@backstage/plugin-techdocs-react';
import { AddonBlueprint } from '@backstage/plugin-techdocs-react/alpha';
import { OfflineCompatibleTechDocsStorageClient } from './OfflineCompatibleTechDocsStorageClient';
import { TechDocsVersionSelector } from './TechDocsVersionSelector';

const offlineCompatibleTechDocsStorageApi = ApiBlueprint.make({
  name: 'storage',
  params: defineParams =>
    defineParams({
      api: techdocsStorageApiRef,
      deps: {
        configApi: configApiRef,
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ configApi, discoveryApi, fetchApi }) =>
        new OfflineCompatibleTechDocsStorageClient({
          configApi,
          discoveryApi,
          fetchApi,
        }),
    }),
});

const techDocsVersionSelector = AddonBlueprint.make({
  name: 'version-selector',
  params: {
    name: 'VersionSelector',
    location: TechDocsAddonLocations.Subheader,
    component: TechDocsVersionSelector,
  },
});

export const techDocsVersionSelectorModule = createFrontendModule({
  pluginId: 'techdocs',
  extensions: [offlineCompatibleTechDocsStorageApi, techDocsVersionSelector],
});
